import DataTable from "../components/common/DataTable";
import { Button, Text } from "@mantine/core";
import React from "react";
import { CSVLink } from "react-csv";
import Head from "../components/common/Head";
import useValidate from "../hooks/useValidate";
import { getAllActiveSubs } from "../utils/api";
import useStore from "../utils/store";

const AllSubsActive = () => {
  const user = useStore((state) => state.user);
  
  const [genres, setGenres] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const getAllGenresData = async () => {
    if (!user?.getAllSubscriptions) {
      return;
    }
    setLoading(true);
    const [success, response] = await getAllActiveSubs();
    if (success) setGenres(response);
    setLoading(false);
  };

  useValidate();
  React.useEffect(() => {
    getAllGenresData();
  }, []);

  if (!user?.getAllSubscriptions) {
    return (
      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <Text c="dimmed">
          You don't have permission to view subscriptions
        </Text>
      </div>
    );
  }

  return (
    <>
      
      <Head
        title="Active Subscription"
        customButton={
          user?.getAllSubscriptions && (
            <CSVLink
              target="_blank"
              data={
                genres?.map((item) => ({
                  name: item?.name,
                  email: item?.email,
                  phoneNumber: item?.phoneNumber,
                  subscriptionType: item?.subscriptionType?.title,
                  subscriptionBuyDate: new Date(
                    item?.subscriptionBuyDate
                  ).toLocaleDateString(),
                  subscriptionExpireDate: new Date(
                    item?.subscriptionExpireDate
                  ).toLocaleDateString(),
                })) || []
              }
              filename={`active_subscription${
                new Date().toLocaleDateString() +
                new Date().toLocaleTimeString()
              }.csv`}
            >
              <Button>Download CSV</Button>
            </CSVLink>
          )
        }
      />

      <DataTable
        loading={loading}
        dataSource={genres}
        scroll={{ x: 1000 }}
        columns={[
          {
            title: "Name",
            dataIndex: "name",
          },
          {
            title: "Email",
            dataIndex: "email",
          },
          {
            title: "Phone Number",
            dataIndex: "phoneNumber",
          },
          {
            title: "Subscription Name",
            dataIndex: ["subscriptionType", "title"],
          },
          {
            title: "Subscription Buy Date",
            dataIndex: "subscriptionBuyDate",
            render: (text) => {
              return new Date(text).toLocaleDateString();
            },
          },
          {
            title: "Subscription Expire Date",
            dataIndex: "subscriptionExpireDate",
            render: (text) => {
              return new Date(text).toLocaleDateString();
            },
          },
        ]}
      />
    </>
  );
};

export default AllSubsActive;
